
import './App.css';

import { Routes, Route } from 'react-router-dom';
import ImageGallery from "./ImageGallery/ImageGallery";
import StartPage from "./StartPage/StartPage";
function App() {
  return (

    <div className="App">
		<Routes> {/* The Switch decides which component to show based on the current URL.*/}
			<Route path='' element={<StartPage />} />
			<Route path='bildgalleri' element={<ImageGallery />} />
		</Routes>

    </div>
  );
}

export default App;
